import styled from 'styled-components'
import { v1 as color, contentLevels } from 'sidecar-design-library'

import BaseList from '../List'
import BaseLoadingSpinner from '../LoadingSpinnerV1'
import BaseIcon from '../IconV1'

export const InputWrap = styled.div`
  position: relative;
`

export const PinIcon = styled(BaseIcon).attrs({ name: 'pin' })`
  width: 1.875rem;
  height: 1.875rem;
  font-size: 1.875rem;
  position: absolute;
  left: 0.625rem;
  top: 0.625rem;
  color: ${color.GREY};
  cursor: pointer;

  // the input is going to be at level, so we're going
  // to make the icons at +1 to show above them.
  z-index: ${contentLevels.components + 1};
`

export const LoadingSpinner = styled(BaseLoadingSpinner)`
  height: 1.875rem;
  width: 1.875rem;
  font-size: 1.875rem;
  position: absolute;
  z-index: 10;
  left: 0.3125rem;
  top: 0.3125rem;
`

export const List = styled(BaseList)`
  border: solid 1px ${color.SILVER};
  background: #fff;
  position: absolute;
  width: 100%;
  // dropdown type list components are given a z-index that is
  // just below the next major content level because in most cases
  // dropdown list options should be above pretty much everything
  // else that could block them, except for everything in the next
  // content level up. This is why we do a -1 here.
  z-index: ${contentLevels.navigation - 1};
`

export const GoogleLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  img {
    height: 0.9375rem;
  }
`

export const Error = styled.small`
  margin-top: 0.3125rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${color.WATERMELON};
  display: block;
`
